<template>
  <v-container>
    <div class="flex-column d-flex" :style="{ gap: '10px' }">
      <div>
        <v-text-field outlined hide-details="auto" label="Name" :value="inputs.name" :error-messages="errors.name"
                      @change="v => setInputs('name', v)" />
      </div>
      <div>
        <v-text-field outlined hide-details="auto" label="Address" :value="inputs.address"
                      :error-messages="errors.address" @change="v => setInputs('address', v)" />
      </div>
      <div>
        <v-text-field outlined hide-details="auto" label="Contact #1" :value="inputs.contactNo1"
                      :error-messages="errors.contactNo1" @change="v => setInputs('contactNo1', v)" />
      </div>
      <div>
        <v-text-field outlined hide-details="auto" label="Contact #2" :value="inputs.contactNo2"
                      :error-messages="errors.contactNo2" @change="v => setInputs('contactNo2', v)" />
      </div>
      <div>
        <v-btn color="warning" dark block :loading="loading" @click="updateConsumer">
          <span class="black--text">Save</span>
        </v-btn>
      </div>
      <div>
        <v-btn color="error" dark block :loading="loading" @click="close">
          <span>Cancel</span>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>
<script>
import { isAxiosError } from 'axios'
import { authAxios } from '../../../../../extra-functions/axios.extra'
import { ConfirmPopup, ErrorPopup, LoadingPopup, SuccessPopup } from '../../../../../lib/utils'

export default {
  name: 'CreateConsumer',
  data() {
    return {
      consumerId: null,
      inputs: {
        name: null,
        address: null,
        contactNo1: null,
        contactNo2: null,
      },
      errors: {},
      loading: false,
    }
  },
  methods: {
    async updateConsumer() {
      try {
        const { isConfirmed } = await ConfirmPopup.fire('Confirm', 'Are you sure you want to update this consumer?')
        if (!isConfirmed) return
        LoadingPopup.fire('Updating', 'Updating consumer on the server...')
        const { data } = await authAxios().put(`/v2/consumers/${this.consumerId}`, {
          ...this.inputs,
        })
        SuccessPopup.fire('Success', data?.message || 'successfully updated')
        this.$emit('success')
      } catch (e) {
        LoadingPopup.close()
        if (isAxiosError(e) && e.status === 422) {
          const { errors = {} } = e.response.data ?? {}
          this.errors = errors
          return
        }
        console.error(e)
        ErrorPopup.fire('Oops', 'something went wrong')
      }
    },
    /**
     * Description
     * @param {ConsumerData} consumer
     * @returns {any}
     */
    setConsumer(consumer) {
      this.inputs = {
        name: consumer.name,
        address: consumer.address,
        contactNo1: consumer.contactNo1,
        contactNo2: consumer.contactNo2,
      }
      this.consumerId = consumer.id
    },
    close() {
      this.$emit('close')
      this.name = null
      this.address = null
      this.contactNo1 = null
      this.contactNo2 = null
    },
    /**
     * Description
     * @param {string} key
     * @param {string} value
     */
    setInputs(key, value) {
      this.inputs = {
        ...this.inputs,
        [key]: value,
      }
    },
  },
}
/**
 * Data shape for a consumer used in Edit.vue
 * @typedef {Object} ConsumerData
 * @property {string|null} id
 * @property {string|null} name
 * @property {string|null} address
 * @property {string|null} contactNo1
 * @property {string|null} contactNo2
 */

</script>
